import React from 'react';
import AFilterForm from '../../../../../components/AFilterForm/AFilterForm';
import AMultiFieldSearchInput from '../../../../../components/AMultiFieldSearchInput/AMultiFieldSearchInput';
import AToggleButtonGroup from '../../../../../components/AToggleButtonGroup/AToggleButtonGroup';
import { EMPTY_FILTER_FORM, getFilterFormFields, searchInputOptions, statusFilterOptions } from './utils';

const Filters = ({
    dropdownData,
    handleFilterForm,
    filterForm,
    getStudentTransfersList
}) => {

    const filterTransferRequests = (filters) => getStudentTransfersList({
        filters: { ...filterForm, ...filters },
        pageNo: 0
    });

    return (
        <div className='d-flex justify-content-between mb-2' style={{ gap: '0.5rem' }}>

            <AMultiFieldSearchInput
                options={searchInputOptions}
                searchHandler={(keyName, inputVal) => filterTransferRequests({ [keyName]: inputVal })}
                crossHandler={(keyName, inputVal) => filterTransferRequests({ [keyName]: inputVal })}
            />

            <AToggleButtonGroup
                options={statusFilterOptions}
                defaultSelected={"ALL"}
                allowDeselect={false}
                changeHandler={(val) => filterTransferRequests({ status: val })}
            />

            <AFilterForm
                containerStyles={{ width: '350px' }}
                formFields={getFilterFormFields(dropdownData)}
                handleFilterForm={handleFilterForm}
                filterForm={filterForm}
                applyFilterHandler={() => filterTransferRequests({})}
                removeFilterHandler={() => filterTransferRequests(EMPTY_FILTER_FORM)}
            />
        </div>
    );
}

export default Filters;